// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal.scss
// module id = 527
// module chunks = 0